// imports
import { atomWithStorage } from 'jotai/utils';

// lib files
import createStorage from '@/lib/helpers/createStorage';
import { canAccessStorage } from '@/lib/helpers/is-storage-available';

// types
import { PassportTransferMembershipWithEmail } from '@/lib/types/passportTransferMembership';

// constants
import { PASSPORT_TRANSFER_MEMBERSHIP_KEY } from '@/lib/constants';

const storage = createStorage<PassportTransferMembershipWithEmail | undefined>('sessionStorage')

let storedPassportTransferMembership = undefined;

if (canAccessStorage('sessionStorage')) {
  const storedValue = window.sessionStorage.getItem(PASSPORT_TRANSFER_MEMBERSHIP_KEY)!

  if(storedValue !== 'undefined') {
    storedPassportTransferMembership = JSON.parse(storedValue) as PassportTransferMembershipWithEmail
  } else {
    window.sessionStorage.removeItem(PASSPORT_TRANSFER_MEMBERSHIP_KEY)
  }
}

const passportTransferMembershipAtom = atomWithStorage<PassportTransferMembershipWithEmail | undefined>(PASSPORT_TRANSFER_MEMBERSHIP_KEY, storedPassportTransferMembership, storage);

export { passportTransferMembershipAtom };
